import { restoreConversationApiConversationsSessionIdRestorePost } from "@noa/api-core";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { reportError } from "../../typed-client";
import { ApiError } from "../../errors";
import { ConversationQueryKey } from "../../query-keys";

const restoreConversationRequest = async (sessionId: string) => {
  await restoreConversationApiConversationsSessionIdRestorePost({
    path: { session_id: sessionId },
    throwOnError: true,
  });
};

export const useRestoreConversation = () => {
  const queryClient = useQueryClient();
  return useMutation<void, ApiError, string>({
    mutationFn: restoreConversationRequest,
    onError: reportError,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ConversationQueryKey.all });
    },
  });
};
